import client from './client'
import store from '@/store'

let homeService = {}

homeService.getHomeContents = async function() {
  try {
    const res = await client.get('/homecontents/')
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

export default homeService
